import type { FC } from 'react';
import { Box, Loader, Text } from '@mantine/core';
import { FileTreeViewState } from './FileTree.enums';

interface FileTreeStateProps {
    state: FileTreeViewState;
}

export const FileTreeState: FC<FileTreeStateProps> = ({ state }) => {
    if (state === FileTreeViewState.NoVersion) {
        return (
            <Box className="flex h-full flex-col bg-gray-1">
                <Box className="flex h-10 shrink-0 items-center justify-between gap-2 border-b border-gray-3 px-3" />
                <Box className="flex flex-1 items-center justify-center px-3 text-center">
                    <Text c="gray.5" size="sm">
                        Select a version to view files.
                    </Text>
                </Box>
            </Box>
        );
    }

    if (state === FileTreeViewState.Loading) {
        return (
            <Box className="flex flex-col items-center gap-2 px-3 py-8 text-center">
                <Loader size="sm" />
                <Text c="gray.5" size="xs">
                    Loading files...
                </Text>
            </Box>
        );
    }

    return (
        <Box className="flex flex-col items-center gap-2 px-3 py-8 text-center">
            <Text fw={600} size="sm">
                No files found
            </Text>
            <Text c="gray.5" size="xs">
                This version has no files. Create a new file to begin.
            </Text>
        </Box>
    );
};
